
import { Colormap } from './colormap'

import 'leaflet'
import 'leaflet/dist/leaflet.css'

import 'leaflet-mouse-position'
import 'leaflet-mouse-position/src/L.Control.MousePosition.css'
import './leaflet/leaflet.polylineDecorator'



let shrines = {}
let shrines_raw = []
let NAMES = {}
let shrine_names = {}
let timings_raw = []
let dungeons = {}

let timings = {}

const plateau_time = 15 * 60; // 15 minute Plateau
const sword_time = 2.5 * 60 // 2m30s time to pull sword
const time_warp = 25.0

const pink_color = "rgb(237,174,192)"
const light_yellow = "rgba(255,255,224,0.33)"
const magenta = 'rgba(255,128,255,0.7)'

// X, Y, Z
const TempleOfTime = [-813.55, 222.00, 1978.16]

let route = [41, 38, 9, 65]
  .map(v => v.toString().padStart(3, '0'))
  .map(v => `Dungeon${v}`)
route.push("TempleOfTime")

let times = [0, 0, 0, 0, plateau_time]

let time = plateau_time;
let pos = TempleOfTime

let count = 4;
let max_count = 40;

const travel_speed = 30 // meters / second

const cmap = new Colormap([
  [-1., [169, 252, 194, 1]],
  [1., [252, 161, 176, 1]],
])
cmap.limits(60 + 30 - 20, 60 + 30 + 20)

function reset_route() {
  pos = TempleOfTime
  route = route.slice(0, 5)
  times = times.slice(0, 5)
  route_markers.invoke('remove')
  route_markers.clearLayers()
}


const app = document.getElementById('app')

function get_name_internal(name: string): string {
  if (name in NAMES)
    return NAMES[name]
  return name
}
function get_name(name: string): string {
  let out = get_name_internal(name);

  if (out.endsWith(" Shrine"))
    out = out.replace(" Shrine", "")
  return out
}

async function load_json(filename) {
  const res = await fetch(filename)
  return res.json()
}

function get_url_arg(arg: string) {
  const pars = new URLSearchParams(window.location.search)
  return pars.get(arg)
}

function name_to_key(name: string) {
  for (const [key, item] of Object.entries(NAMES)) {
    if (!key.startsWith('Dungeon'))
      continue
    if (name in shrine_names) {
      return shrine_names[name]
    }
  }
  return undefined
}

async function main() {
  shrines_raw = await load_json("shrines.json")
  NAMES = await load_json("LocationMarker.json")
  timings_raw = await load_json("timings.json")
  dungeons = await load_json('Dungeon.json')
  shrine_names['TempleOfTime'] = 'TempleOfTime'
  shrine_names['Paraglider'] = 'TempleOfTime'
  for (const item of shrines_raw) {
    if (item.messageid == "StartPoint")
      continue
    const num = parseInt(item.messageid.replace("Dungeon", ""))
    if (num >= 120)
      continue;
    shrines[item.messageid] = item
    let n = get_name(item.messageid)
    if (n != item.messageid) {
      n = n.replace("Shrine", "").trim()
      shrine_names[n] = item.messageid
      n = n.replaceAll("'", "")
      shrine_names[n] = item.messageid

      let q = n.toLowerCase() // Lowercase
      shrine_names[q] = item.messageid
      let m = n.replaceAll(' ', '') // No Spaces
      shrine_names[m] = item.messageid
      let k = m.toLowerCase() // Lowercase No Spaces
      shrine_names[k] = item.messageid
    }
  }
  for (const t of timings_raw) {
    if (t.start == 'Hateno Ancient Tech Lab')
      continue
    if (t.start == 'start')
      continue

    if (t.end == 'Paraglider')
      continue
    if (t.end == 'Dark Beast')
      continue
    if (t.warp !== null)
      continue
    let start = name_to_key(t.start)
    let end = name_to_key(t.end)
    if (!start)
      console.log("unknown start key", t.start, start)
    if (!end)
      console.log("unknown end key", t.end, end)
    if (!start || !end)
      return
    if (!(timings[start]))
      timings[start] = {}
    if (!(timings[start][end]))
      timings[start][end] = []
    //console.log(start, end, t.t)
    timings[start][end].push(t.t)
  }

  const order = get_url_arg("s")
  if (order) {
    const nums = order.split(",")//.map(v => name_to_num(v).map(v => parseInt(v))
    document.getElementById('txt').value = nums.join("\n")
    update_list(nums)
  } else {
    update_from_txt()
    //add_selector(pos, route, {}, false)
  }
}


function update_list(names: string[]) {
  reset_route()

  app.innerHTML = `<div class="row header">
<div class="number">Num.</div>
<div>Shrine</div>
<div class="time">Split time</div>
<div class="time">Total time</div>
</div>`

  add_selector(pos, route, {}, false)
  let prev_pos = pos
  let key = route.at(-1)

  for (let i of names) {
    let extra = 0
    let warp = false
    if (i.includes(" warp ") || i.includes(" Warp ")) {
      let k = i.indexOf(" Warp ")
      if (k < 0) {
        k = i.indexOf(" warp ")
      }
      const start = i.slice(k + 5).trim()
      i = i.slice(0, k).trim()
      let tmp = name_to_key(start)
      if (!tmp) {
        //console.log(shrine_names)
        //console.log("unknown name", start)
        return
      }
      prev_pos = pos
      pos = shrines[tmp].pos
      extra = time_warp
      warp = true
      const markers = draw_map_line(prev_pos, pos, light_yellow, `Warp to ${get_name(tmp)}`)
      markers.forEach(m => route_markers.addLayer(m))
    }
    const v = name_to_key(i)
    if (!v) {
      //console.log(shrine_names)
      //console.log("unknown name", i)
      return
    }
    const prev_key = key
    key = v
    const t = time_to(pos, key, prev_key)
    prev_pos = pos
    pos = shrines[key].pos
    route.push(key)
    times.push(t.time + extra)
    add_selector(pos, route, t, warp)
    let c = cmap.at(t.time + extra)
    if (!t.measured)
      c = magenta
    const markers = draw_map_line(prev_pos, pos, c, `${get_name(prev_key)} to ${get_name(key)}<br>${s2ms(t.time + extra)}`)
    markers.forEach(m => route_markers.addLayer(m))
  }
  route.push("MasterSword")
  times.push(sword_time)
  add_selector(pos, route, {}, false)
}

function draw_map_line(a: number[], b: number[], color: string, tooltip: string): L.Layer[] {
  if (!map)
    return []
  let line = [[a[2], a[0]], [b[2], b[0]]]
  //console.log(line)
  let marker = L.polyline(line, { weight: 3, color }).addTo(map)
  let head = arrow_head(marker, color).addTo(map);
  if (tooltip && tooltip.length)
    marker.bindTooltip(tooltip);
  return [marker, head]
}
function arrow_head(line: any, color: string) {
  return L.polylineDecorator(line, {
    patterns: [
      {
        offset: '100%', repeat: 0, symbol:
          L.Symbol.arrowHead({
            pixelSize: 7.5, polygon: false,
            pathOptions: { weight: 2, stroke: true, color: color }
          })
      }
    ]
  });
}


async function add_selector(pos: number[], route: string[], timing: any, warp: boolean) {
  //const left = sort_by_time(pos, route)
  const id = route.at(-1)
  let time = 0.0
  for (const t of times) {
    time += t
  }

  const ele = document.createElement('div')
  ele.classList.add('times')

  const num = document.createElement('div')
  num.classList.add('number')
  num.textContent = `${route.length - 1}`
  ele.appendChild(num)

  const label = document.createElement('div')
  label.textContent = get_name(id)
  let sub = dungeons[`${id}_sub`]
  if (sub && sub.includes("Test of Strength")) {
    label.textContent += " (ToS)"
  }
  ele.appendChild(label)

  const split = document.createElement('div')
  const t = times.at(-1)
  let c = cmap.at(t)
  if (timing && !timing.measured)
    c = magenta

  if (!(id == 'TempleOfTime' || id == 'MasterSword')) {
    split.style.color = c
  }
  split.classList.add('time')
  split.textContent = `${s2ms(times.at(-1))}`

  if (timing && !(timing.measured)) {
    split.textContent += " *"
  }
  if (warp) {
    split.textContent += " W"
  }
  ele.appendChild(split)


  const tdiv = document.createElement('div')
  tdiv.classList.add('time')
  tdiv.textContent = s2ms(time)
  ele.appendChild(tdiv)
  app.appendChild(ele)


  //const sle = document.createElement('select')
  //const opt = document.createElement('option')
  //opt.textContent = `Select a shrine`
  //opt.value = "none"
  //opt.dataset.time = "0.0"
  //sle.appendChild(opt)

  //for (const item of left) {
  //  const opt = document.createElement('option')
  //  opt.textContent = `${item.time_fmt} ${get_name(item.name)}`
  //  opt.value = item.name
  //  opt.dataset.time = item.time
  //  sle.appendChild(opt)
  //}
  //ele.appendChild(sle)

  /*
  sle.addEventListener('change', (ev) => {
    const new_id = ev.target.value
    if (new_id == "none")
      return
    const idx = ev.target.selectedIndex
    const t = Number(ev.target.options[idx].dataset.time)
    const new_pos = shrines[new_id].pos
    times.push(t)
    route.push(new_id)
    add_selector(new_pos, route)
    //return true;
  })
  */
}

function dist2(a: number[], b: number[]): number {
  let dx = a[0] - b[0]
  let dz = a[2] - b[2]
  return Math.sqrt(dx * dx + dz * dz)
}

function s2ms(v: number): string {
  let h = Math.floor(v / 3600)
  let m = Math.floor((v - h * 3600) / 60)
  let s = v - m * 60 - h * 3600
  let ss = s.toFixed(2).padStart(5, '0')
  if (h <= 0)
    return `${m}:${ss}`
  //console.log(h, m, s)
  let ms = m.toFixed(0).padStart(2, '0')
  return `${h}:${ms}:${ss}`
}

function time_to(pos: number[], to_name: string, from_name: string) {
  let dist = dist2(pos, shrines[to_name].pos)
  let time_control = 25
  let time_shrine = 30
  let time_dist = dist / travel_speed
  let time = time_control + time_shrine + time_dist
  let measured = false

  if (timings[from_name] && timings[from_name][to_name]) {
    time = Math.min(...timings[from_name][to_name])
    measured = true
  }
  const time_fmt = s2ms(time)
  return {
    to_name, dist, time_control, time_dist, time_shrine, time, time_fmt, measured, pos: shrines[to_name].pos
  }

}

function sort_by_time(pos: number[], route: string[]) {
  const remain = Object.keys(shrines).filter((v: string) => !(route.includes(v)))

  let prev_key = route.at(-1)
  let out = []
  for (const name of remain) {
    out.push(time_to(pos, name, prev_key))
    //prev_key = name
  }
  out.sort((a, b) => a.time - b.time)
  return out
}

const txt_ele = document.getElementById('txt')
txt_ele.addEventListener('input', (ev) => {
  update_from_txt()
})

const init = document.getElementById('init')

const orcrist_route = `boshkala\nwahgokatta\nhilarao\nshehrata\ndakatuss\ntalohnaeg\nhadahamar\ntotosah\nreedahee\nsheevaneer\nsheevenath\nqukahnata\nshodasah\nshaiutoh\nkaomakagh\npumaagnitae\nyanaga\nsohkofi warp sheh rata\ntahmuhl\nmoakeet\nsahdahaj\nzekasho\nzunakai\nkatosaaug\njeenoh warp keh namut\ndahkaso\nrotaooh\nkaamyatak\nkatahchuki\nzaltawa\nmonyatoma\nmaagnorah\nrinoyaa\nshagehma\nqazatokki\nkeo ruug`

init.addEventListener('click', (ev) => {
  txt_ele.value = orcrist_route
  update_from_txt()
})

function update_from_txt() {
  const lines = txt_ele.value.split("\n").map(v => v.trim()).filter(v => v.length)
  update_list(lines)
  const link = document.getElementById('link')
  link.href = '?s=' + lines.join(",")

}

let shrine_icon = L.icon({
  iconUrl: 'mapicon_dungeon.svg',
  iconSize: [36, 36],
  iconAnchor: [18, 18],
});
let shrine_dlc_icon = L.icon({
  iconUrl: 'mapicon_dungeon_dlc.svg',
  iconSize: [36, 36],
  iconAnchor: [18, 18],
});


function draw_shrines() {

  for (const shrine of shrines_raw) {
    if (shrine.messageid == "StartPoint") {
      continue;
    }
    const n = parseInt(shrine.messageid.slice(-3));
    let name = dungeons[shrine.messageid];
    let icon = shrine_icon;
    if (n > 119) {
      icon = shrine_dlc_icon;
    }
    const y = shrine.pos[1].toFixed(0);
    name = name.replace("Shrine", "").trim();
    L.marker([shrine.pos[2], shrine.pos[0]], { icon: icon })
      .bindTooltip(`${name} - ${y}m`)
      .addTo(map)
      .on("click", (ev: any) => { select_shrine(shrine) });
  }
}

const nearest: L.LayerGroup = L.layerGroup([]);
const route_markers: L.LayerGroup = L.layerGroup([]);

function clear_nearest() {
  nearest.invoke('remove')
  nearest.clearLayers()
}

function select_shrine(shrine: any) {
  const key = shrine.messageid
  const pos = shrine.pos
  clear_nearest()
  const to_shrines = sort_by_time(pos, [key])
  for (const s of to_shrines.slice(0, 10)) {
    let c = cmap.at(s.time)
    let m = ""
    if (!s.measured) {
      c = magenta
      m = " *"
    }

    let markers = draw_map_line(pos, s.pos, c, `${get_name(s.to_name)}<br>${s.time_fmt}${m}`)
    markers.forEach(m => nearest.addLayer(m))
  }
}

let map = undefined;

function map_setup() {
  var TILE_SIZE = 256;
  var MAP_SIZE = [24000, 20000];
  const crs = L.Util.extend({}, L.CRS.Simple);
  crs.transformation = new L.Transformation(4 / TILE_SIZE,
    MAP_SIZE[0] / TILE_SIZE,
    4 / TILE_SIZE,
    MAP_SIZE[1] / TILE_SIZE);
  let MIN_ZOOM = 2;
  let MAX_ZOOM = 7;

  map = L.map('map', {
    minZoom: MIN_ZOOM,
    maxZoom: MAX_ZOOM,
    zoomControl: false,
    center: [0, 0],
    zoom: 3,
    crs: crs
  });
  L.tileLayer("https://objmap.zeldamods.org/game_files/maptex/{z}/{x}/{y}.png", {
    attribution: '<a href="https://objmap.zeldamods.org/">Zeldamods Object Map</a>',
    minZoom: MIN_ZOOM,
    maxZoom: MAX_ZOOM,
    tileSize: 256,
  }).addTo(map);
  var sW = map.unproject([-6000, -5000], 0);
  var nE = map.unproject([6000, 5000], 0);
  map.setMaxBounds(L.latLngBounds(sW, nE));

  //var tr = L.transformation(1.0, 0.0, 1.0, 0.0);
  //L.control.zoom({
  //  position: 'topright'
  //}).addTo(map);

  L.control.mousePosition({
    lngFirst: true,
    wrapLng: false,
    position: 'bottomright',
    latFormatter: ((x: number) => (-x).toFixed(2)),
    lngFormatter: (x => x.toFixed(2)),
  }).addTo(map);

  // Catch "Almost" clicks for people with fat fingers on touch screens
  //   The fingers you have used to dial are too fat ...
  //   https://www.youtube.com/watch?v=OqjF7HKSaaI
  map.on('almost:click', function(ev: any) {
    var layer = ev.layer;
    if (layer.openPopup) {
      layer.fire('click', ev);
    }
  });

  map.on('click', (ev: any) => {
    clear_nearest()
  })

  draw_shrines()

}


async function main_map() {
  await main()
  map_setup()
  update_from_txt()
}

const map_ele = document.getElementById('map')
if (!map_ele) {
  main()
} else {
  main_map()
}

const right_ele = document.getElementById("right")
const right_fake_ele = document.getElementById("fakeright")
const right_close_ele = document.getElementById("right_close")
const right_open_ele = document.getElementById("right_open")
if (right_close_ele) {
  right_close_ele.addEventListener('click', (ev) => {
    right_ele.style.display = 'none';
    right_fake_ele.style.display = 'block';
  })
}
if (right_open_ele) {
  right_open_ele.addEventListener('click', (ev) => {
    right_ele.style.display = 'block';
    right_fake_ele.style.display = 'none';
  })
}
const left_ele = document.getElementById("left")
const left_fake_ele = document.getElementById("fakeleft")
const left_close_ele = document.getElementById("left_close")
const left_open_ele = document.getElementById("left_open")
if (left_close_ele) {
  left_close_ele.addEventListener('click', (ev) => {
    left_ele.style.display = 'none';
    left_fake_ele.style.display = 'block';
  })
}
if (left_open_ele) {
  left_open_ele.addEventListener('click', (ev) => {
    left_ele.style.display = 'block';
    left_fake_ele.style.display = 'none';
  })
}

